import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home,
    redirect: "/welcome",
    children: [{
        path: '/welcome',
        name: 'Welcome',
        component: () => import( /* webpackChunkName: "about" */ '../views/User/Welcome.vue')
      }, {
        path: '/map',
        name: 'Map',
        component: () => import('../views/User/Map.vue')
      },
      {
        path: '/chart',
        name: 'Chart',
        component: () => import('../views/User/Chart.vue')
      }, {
        path: '/list',
        name: 'List',
        component: () => import('../views/User/List.vue')
      }, {
        path: '/articleList',
        name: 'ArticleList',
        component: () => import('../views/User/ArticleList.vue')
      }, {
        path: '/article',
        name: 'Article',
        component: () => import('../views/User/Article.vue')
      }, {
        path: '/login',
        name: 'Login',
        component: () => import('../views/User/Login.vue')
      }, {
        path: '/user',
        name: 'User',
        component: () => import('../views/User/User.vue')
      }, {
        path: '/upload',
        name: 'Upload',
        component: () => import('../views/User/Upload.vue')
      }, {
        path: '/message',
        name: 'Message',
        component: () => import('../views/User/Message/index.vue')
      },
      {
        path: '/scripture',
        name: 'Scripture',
        component: () => import('../views/User/Scripture/index.vue')
      },
      {
        path: '/bimap',
        name: 'BiMap',
        component: () => import('../views/User/BIMap/index.vue')
      },
    ]
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('../views/Test/upTest.vue')
  }, {
    path: '*',
    name: '404',
    component: () => import('../views/User/404.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router